import { getGlobalsForIframe as baseGetGlobalsForIframe } from 'core-components/sitebuilder/helpers/getGlobalsForIframe'
import { getAppOwnerId } from 'src/core/classes/helpers/getAppId'
import { authService } from 'src/core/classes/services/AuthService'

export const getGlobalsForIframe = async (src?: string) => {
  const hasOneTimeToken = src?.includes('oneTimeToken')

  return await baseGetGlobalsForIframe({
    src,
    oneTimeToken: hasOneTimeToken ? await authService.getOneTimeToken() : '',
    ownerId: getAppOwnerId(),
  })
}
